import { COUNTRY_CODES } from "@src/pages/trouble-shooting/constant/country-code";

export interface CountryData {
    code: string;
    name: string;
}

export const generateCountries = (locale = "en"): CountryData[] => {
    try {
        const regionNamesInEnglish = new Intl.DisplayNames([locale], { type: "region" });

        return COUNTRY_CODES.map((code) => {
            let name: string;

            try {
                name = regionNamesInEnglish.of(code) || code;
            } catch (error) {
                console.warn(`Failed to get country name for code: ${code}`, error);
                name = code;
            }

            return {
                code,
                name,
            };
        }).sort((a, b) => a.name.localeCompare(b.name));
    } catch (error) {
        console.error("Failed to initialize Intl.DisplayNames", error);
        return COUNTRY_CODES.map((code) => ({
            code,
            name: code,
        })).sort((a, b) => a.code.localeCompare(b.code));
    }
};

export const getCountryName = (code: string, locale = "en"): string => {
    try {
        const regionNamesInEnglish = new Intl.DisplayNames([locale], { type: "region" });
        return regionNamesInEnglish.of(code) || code;
    } catch (error) {
        console.warn(`Failed to get country name for code: ${code}`, error);
        return code;
    }
};
